import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

export interface TabItem {
  id: string
  label: string
  count?: number
}

interface TabsProps {
  tabs: TabItem[]
  activeTab: string
  onTabChange: (tabId: string) => void
  className?: string
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className,
}) => {
  return (
    <div
      className={
        className
          ? `${css(styles.tabsContainer)} ${className}`
          : css(styles.tabsContainer)
      }
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={css(
            styles.tabButton,
            activeTab === tab.id && styles.activeTab,
          )}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
          {tab.count !== undefined && (
            <span className={css(styles.tabCount)}>({tab.count})</span>
          )}
        </button>
      ))}
    </div>
  )
}

const styles = StyleSheet.create({
  tabsContainer: {
    display: 'flex',
    gap: '8px',
  },
  tabButton: {
    backgroundColor: '#E5E7EB',
    color: '#4B5563',
    padding: '6px 12px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: '#D1D5DB',
    },
    ':focus': {
      outline: 'none',
      boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.2)',
    },
  },
  activeTab: {
    backgroundColor: '#1C64F2',
    color: 'white',
    ':hover': {
      backgroundColor: '#1955CC',
    },
  },
  tabCount: {
    fontSize: '12px',
    fontWeight: 600,
    opacity: 0.8,
  },
})

export default Tabs
